import React, { useEffect, useState, useRef } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { AiOutlineMenu } from 'react-icons/ai';

import { useStateContext } from 'shared/contexts/ContextProvider';
import { convertLinks } from 'shared/utils/links';
import Tooltip from 'shared/ui/Tooltip';
import Cart from 'shared/layout/Cart';
import Chat from 'shared/layout/Chat';
import Notification from 'shared/layout/Notification';
import UserProfile from 'shared/layout/UserProfile';
import avatar from 'shared/assets/avatar.jpg';

// Icons component remains the same
const Icons = () => (
  <svg xmlns='http://www.w3.org/2000/svg' className='hidden'>
    <symbol id='icon-dashboard' viewBox='0 0 24 24'>
      <path d='M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z' />
    </symbol>
    <symbol id='icon-docs' viewBox='0 0 24 24'>
      <path d='M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z' />
    </symbol>
    <symbol id='icon-company' viewBox='0 0 24 24'>
      <path d='M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' />
    </symbol>
    <symbol id='icon-parties' viewBox='0 0 24 24'>
      <path d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' />
    </symbol>
    <symbol id='icon-products' viewBox='0 0 24 24'>
      <path d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z' />
    </symbol>
    <symbol id='icon-app' viewBox='0 0 24 24'>
      <path d='M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' />
    </symbol>
    <symbol id='icon-crm' viewBox='0 0 24 24'>
      <path d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' />
    </symbol>
    <symbol id='icon-dev' viewBox='0 0 24 24'>
      <path d='M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' />
    </symbol>
    <symbol id='icon-pos' viewBox='0 0 24 24'>
      <path d='M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' />
    </symbol>
    <symbol id='icon-stats' viewBox='0 0 24 24'>
      <path d='M3 17h3v4H3v-4zm5-6h3v10H8V11zm5-5h3v15h-3V6zm5 8h3v7h-3v-7z' />
    </symbol>
    <symbol id='icon-templates' viewBox='0 0 24 24'>
      <path d='M3 3h18v4H3V3zm0 7h18v4H3v-4zm0 7h18v4H3v-4z' />
    </symbol>
    <symbol id='icon-util_apps' viewBox='0 0 24 24'>
      <path d='M6 3h12v2H6V3zm2 14h8v2H8v-2zm2-7h4v2h-4v-2z' />
    </symbol>
    <symbol id='icon-consultants' viewBox='0 0 24 24'>
      <path d='M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' />
    </symbol>
  </svg>
);


const NavIcon = ({ iconId, color }) => (
  <div className='mb-1'>
    <svg
      className={`w-5 h-5`}
      style={{ fill: color }}
    >
      <use href={`#${iconId}`} />
    </svg>
  </div>
);

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <Tooltip content={title} position='BottomCenter'>
    <button
      type='button'
      onClick={() => customFunc()}
      style={{ color }}
      className='relative text-xl rounded-full p-3 hover:bg-opacity-80'
    >
      {dotColor && (
        <span
          style={{ background: dotColor }}
          className='absolute inline-flex rounded-full h-2 w-2 right-2 top-2'
        />
      )}
      {icon}
    </button>
  </Tooltip>
);

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    navbarState,
    handleClick,
    screenSize,
    setScreenSize,
    user,
    token
  } = useStateContext();

  const [currentLinks, setCurrentLinks] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.sections) {
      const parsedLinks = convertLinks(user.sections);
      setCurrentLinks(parsedLinks);
      const currentPath = location.pathname.split('/')[1];
      const currentSection = parsedLinks.find(section => section.url === currentPath);
      setSelectedSection(currentSection?.title || parsedLinks[0]?.title);
    }
  }, [user]);

  useEffect(() => {
    if (location.pathname === '/' && currentLinks.length > 0) {
      const firstSection = currentLinks[0];
      if (firstSection.links && firstSection.links.length > 0) {
        navigate(`/${firstSection.links[0].url}/`);
      }
    }
  }, [location.pathname, currentLinks, navigate]);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  if (!token || !user) return <p>Loading...</p>;

  const isLinkActive = (isActive, link) => {
    return isActive || location.pathname === `${link}` || location.pathname.includes(`${link}/archived`) || location.pathname.includes(`${link}/new`);
  }

  return (
    <div className='w-full fixed top-0 z-50'>
      <Icons />

      {/* Main Navbar */}
      <div style={{ backgroundColor: currentColor }} className='text-white'>

        <div className='mx-auto px-2'>
          <div className='flex items-center py-2'>
            {/* Logo */}
            <Link
              to='/'
              className='items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold'
            >
              <svg width='459' height='50' viewBox='0 0 459 125' fill='none' className='pr-2 mr-4 w-32 h-12' xmlns='http://www.w3.org/2000/svg'>
                <path d='M174.955 83.4404C176.313 85.012 177.029 87.0427 176.958 89.1235C176.965 90.292 176.687 91.4444 176.15 92.4803C175.612 93.5162 174.831 94.4041 173.873 95.0665C171.822 96.5016 169.362 97.2281 166.865 97.1368H166.646C162.926 97.184 159.286 96.0474 156.247 93.8893C153.206 91.6986 150.808 88.7262 149.302 85.2833C147.631 81.4471 146.805 77.2926 146.88 73.1051V8.26829C146.846 7.19505 147.027 6.12588 147.412 5.12431C147.797 4.12273 148.378 3.20919 149.121 2.43792C149.864 1.66665 150.754 1.05341 151.737 0.634604C152.721 0.215803 153.778 0 154.846 0C155.914 0 156.971 0.215803 157.954 0.634604C158.937 1.05341 159.827 1.66665 160.57 2.43792C161.313 3.20919 161.894 4.12273 162.279 5.12431C162.664 6.12588 162.845 7.19505 162.811 8.26829V73.0726C162.719 75.2229 163.193 77.3596 164.184 79.2673C165.242 81.0859 166.267 81.0859 166.655 81.0859H169.602C170.61 81.0675 171.61 81.2683 172.534 81.6747C173.458 82.0811 174.284 82.6833 174.955 83.4404ZM69.1792 62.5101C69.257 68.768 67.6739 74.9336 64.5929 80.3714C59.8462 88.2947 52.2104 94.0414 43.312 96.3874C34.4136 98.7334 24.9558 97.4933 16.9533 92.9312C11.8203 89.9045 7.57271 85.5692 4.6397 80.3633C1.59734 74.9075 0.00130872 68.7568 0.00493145 62.5019V8.39007C-0.0336681 7.29911 0.154671 6.21208 0.557885 5.19851C0.961099 4.18494 1.57032 3.26716 2.34654 2.50393C3.48217 1.34522 4.9378 0.556266 6.52471 0.239342C8.11162 -0.0775809 9.75661 0.0921505 11.2464 0.726526C12.7363 1.3609 14.0022 2.43066 14.8801 3.79712C15.758 5.16358 16.2074 6.76371 16.1701 8.39007V35.3526C18.2932 33.5028 20.6432 31.934 23.1626 30.6843C27.9408 28.3926 33.2109 27.3323 38.4982 27.5987C43.7855 27.8652 48.9237 29.4501 53.4501 32.2107C58.2909 35.3097 62.241 39.6286 64.9078 44.738C67.7661 50.216 69.2204 56.3244 69.1388 62.5101H69.1792ZM55.0004 62.3639C55.002 58.4308 53.8434 54.5855 51.6711 51.3145C49.4989 48.0435 46.4106 45.4938 42.797 43.9879C39.1834 42.482 35.2067 42.0875 31.3701 42.8545C27.5335 43.6214 24.0093 45.5152 21.2433 48.2964C18.4773 51.0776 16.5938 54.6212 15.831 58.4788C15.0683 62.3365 15.4606 66.335 16.9582 69.9685C18.4559 73.6019 20.9917 76.7071 24.2448 78.8913C27.498 81.0754 31.3223 82.2404 35.234 82.2388C40.4694 82.228 45.4867 80.1293 49.1848 76.4032C52.883 72.6771 54.96 67.628 54.96 62.3639H55.0004ZM242.377 60.6833V88.5065C242.362 90.1136 241.878 91.6809 240.985 93.014C240.092 94.347 238.83 95.3872 237.354 96.0053C235.879 96.6235 234.255 96.7925 232.685 96.4914C231.115 96.1903 229.667 95.4323 228.521 94.3115C227.157 92.9522 226.343 91.1326 226.236 89.2047C224.93 90.3627 223.531 91.4109 222.054 92.3386C217.062 95.3787 211.337 96.986 205.501 96.986C199.665 96.986 193.94 95.3787 188.948 92.3386C184.078 89.2582 180.104 84.9396 177.426 79.8194C174.578 74.3359 173.135 68.2247 173.227 62.0392C173.149 55.7813 174.733 49.6157 177.814 44.1778C180.79 38.9662 185.079 34.6344 190.248 31.618C195.432 28.5175 201.334 26.838 207.365 26.7471C213.396 26.6561 219.346 28.1569 224.62 31.0996C229.894 34.0424 234.308 38.3243 237.423 43.5181C240.537 48.7119 242.243 54.6361 242.369 60.6996L242.377 60.6833ZM226.769 62.3639C226.771 58.4308 225.612 54.5855 223.44 51.3145C221.268 48.0435 218.18 45.4938 214.566 43.9879C210.952 42.482 206.976 42.0875 203.139 42.8545C199.302 43.6214 195.778 45.5152 193.012 48.2964C190.246 51.0776 188.363 54.6212 187.6 58.4788C186.837 62.3365 187.229 66.335 188.727 69.9685C190.225 73.6019 192.761 76.7071 196.014 78.8913C199.267 81.0754 203.091 82.2404 207.003 82.2388C212.238 82.228 217.256 80.1293 220.954 76.4032C224.652 72.6771 226.729 67.628 226.729 62.3639H226.769ZM389.503 60.6833V88.5065C389.486 90.112 389.001 91.6774 388.109 93.0087C387.216 94.3401 385.955 95.3791 384.481 95.9969C383.007 96.6148 381.386 96.7844 379.817 96.4848C378.248 96.1852 376.801 95.4296 375.655 94.3115C374.289 92.953 373.472 91.1335 373.362 89.2047C372.055 90.3627 370.656 91.4109 369.179 92.3386C364.187 95.3787 358.463 96.986 352.627 96.986C346.79 96.986 341.066 95.3787 336.074 92.3386C331.204 89.2582 327.229 84.9396 324.551 79.8194C321.703 74.3359 320.26 68.2247 320.353 62.0392C320.275 55.7813 321.858 49.6157 324.939 44.1778C327.981 38.886 332.354 34.4921 337.62 31.4374C342.885 28.3827 348.857 26.7746 354.936 26.7746C361.015 26.7746 366.987 28.3827 372.252 31.4374C377.517 34.4921 381.89 38.886 384.933 44.1778C387.8 49.2162 389.368 54.8959 389.495 60.6996L389.503 60.6833ZM373.895 62.3639C373.896 58.4308 372.738 54.5855 370.566 51.3145C368.393 48.0435 365.305 45.4938 361.691 43.9879C358.078 42.482 354.101 42.0875 350.264 42.8545C346.428 43.6214 342.904 45.5152 340.138 48.2964C337.372 51.0776 335.488 54.6212 334.725 58.4788C333.963 62.3365 334.355 66.335 335.853 69.9685C337.35 73.6019 339.886 76.7071 343.139 78.8913C346.392 81.0754 350.217 82.2404 354.128 82.2388C359.365 82.2302 364.384 80.1324 368.084 76.4061C371.784 72.6798 373.862 67.6294 373.862 62.3639H373.895ZM142.205 61.2679V89.0911C142.192 90.6983 141.71 92.2661 140.818 93.5999C139.926 94.9337 138.664 95.9745 137.188 96.593C135.713 97.2115 134.089 97.3804 132.519 97.0787C130.949 96.7769 129.502 96.0179 128.357 94.896C126.991 93.5375 126.174 91.7181 126.064 89.7893C124.757 90.9453 123.361 91.9959 121.89 92.9312C116.895 95.9645 111.171 97.5677 105.337 97.5677C99.5021 97.5677 93.7784 95.9645 88.7841 92.9312C83.9176 89.8433 79.944 85.5231 77.2618 80.4039C74.4146 74.923 72.9715 68.8147 73.063 62.6318C72.9833 56.3737 74.5666 50.2076 77.6493 44.7705C80.6899 39.4766 85.0626 35.0807 90.3281 32.0244C95.5935 28.9681 101.566 27.3591 107.646 27.3591C113.726 27.3591 119.699 28.9681 124.964 32.0244C130.23 35.0807 134.602 39.4766 137.643 44.7705C140.499 49.8038 142.062 55.4742 142.189 61.2679H142.205ZM126.597 62.3639C126.597 58.4331 125.438 54.5904 123.266 51.322C121.094 48.0536 118.007 45.5062 114.395 44.002C110.783 42.4977 106.809 42.1041 102.974 42.871C99.1401 43.6378 95.618 45.5307 92.8537 48.3103C90.0893 51.0898 88.2067 54.6312 87.444 58.4865C86.6813 62.3419 87.0728 66.338 88.5688 69.9697C90.0649 73.6013 92.5984 76.7054 95.849 78.8893C99.0995 81.0731 102.921 82.2388 106.831 82.2388C112.073 82.2388 117.101 80.1448 120.808 76.4176C124.514 72.6903 126.597 67.6351 126.597 62.3639ZM315.992 62.6318C316.083 68.8146 314.64 74.9226 311.794 80.4039C309.114 85.5249 305.14 89.8456 300.271 92.9312C295.745 95.6863 290.608 97.2679 285.323 97.5343C280.038 97.8008 274.77 96.7435 269.992 94.4576C267.47 93.21 265.119 91.6381 263 89.7811V116.752C263.025 117.815 262.841 118.873 262.457 119.864C262.073 120.855 261.497 121.759 260.763 122.524C259.633 123.695 258.179 124.498 256.59 124.83C255.001 125.161 253.35 125.006 251.85 124.385C250.349 123.763 249.069 122.704 248.173 121.343C247.278 119.983 246.809 118.383 246.826 116.752V62.6318C246.823 56.3759 248.422 50.2245 251.469 44.7705C254.398 39.561 258.646 35.2246 263.783 32.2025C267.724 29.8561 272.09 28.3192 276.626 27.6807C281.162 27.0423 285.779 27.315 290.21 28.4831C294.641 29.6513 298.797 31.6916 302.438 34.4859C306.079 37.2803 309.133 40.7732 311.422 44.7624C314.511 50.2007 316.1 56.3696 316.025 62.6318H315.992ZM302.137 62.3639C302.138 58.4308 300.98 54.5855 298.807 51.3145C296.635 48.0435 293.547 45.4938 289.933 43.9879C286.32 42.482 282.343 42.0875 278.506 42.8545C274.67 43.6214 271.146 45.5152 268.38 48.2964C265.614 51.0776 263.73 54.6212 262.967 58.4788C262.205 62.3365 262.597 66.335 264.095 69.9685C265.592 73.6019 268.128 76.7071 271.381 78.8913C274.634 81.0754 278.459 82.2404 282.37 82.2388C287.613 82.2388 292.64 80.1448 296.347 76.4176C300.054 72.6903 302.137 67.6351 302.137 62.3639ZM393.96 55.0002L455.019 41.9289C452.51 37.2396 448.697 33.3861 444.046 30.8386C439.253 28.2988 433.903 27.0091 428.486 27.0877C423.244 27.0217 418.071 28.2956 413.452 30.7899C412.275 31.436 411.142 32.1602 410.06 32.9576C409.696 31.8239 409.068 30.794 408.228 29.9536C406.645 28.5045 404.582 27.7014 402.442 27.7014C400.302 27.7014 398.239 28.5045 396.657 29.9536C395.882 30.7178 395.273 31.6357 394.87 32.6491C394.467 33.6624 394.278 34.749 394.315 35.8398V88.7744C394.335 90.3892 394.825 91.9626 395.727 93.2992C396.628 94.6358 397.9 95.6767 399.385 96.2925C400.87 96.9083 402.501 97.072 404.078 96.7631C405.654 96.4541 407.106 95.6863 408.252 94.555C408.987 93.7905 409.564 92.8863 409.948 91.8951C410.332 90.904 410.516 89.8459 410.488 88.7825V55.2762C410.436 52.9272 411.132 50.6227 412.475 48.7C413.916 46.6703 415.843 45.0394 418.078 43.9586C420.593 42.7322 423.359 42.1175 426.153 42.1643C429.158 42.1042 432.136 42.7403 434.857 44.0235C437.301 45.2382 439.323 47.1686 440.655 49.5605C442.116 52.0693 442.851 55.4305 442.851 59.5467V88.7744C442.851 90.9277 443.702 92.9927 445.216 94.5153C446.73 96.0378 448.784 96.8932 450.925 96.8932C453.067 96.8932 455.121 96.0378 456.635 94.5153C458.149 92.9927 459 90.9277 459 88.7744V59.5467C459 52.6619 457.66 46.7271 455.019 41.9289L393.96 55.0002Z' fill='#FFFFFF' />
              </svg>
            </Link>

            {/* Navigation */}
            <div className='hidden md:flex gap-4'>
              {currentLinks.map((item) => (
                <button
                  key={item.title}
                  className={`flex flex-col items-center px-3 py-2 rounded hover:bg-opacity-80 transition-colors
                    ${selectedSection === item.title ? 'bg-gray-200 text-blue-600' : ''}`}
                  onClick={() => setSelectedSection(item.title)}
                >
                  <NavIcon
                    iconId={`icon-${item.url?.toLowerCase()}`}
                    color={`${selectedSection === item.title ? 'blue' : 'white'}`} />
                  <span className='text-sm'>{item.title}</span>
                </button>
              ))}
            </div>

            {/* Right side - Profile */}
            <div className='flex items-center ml-auto'>
              <div className='md:hidden'>
                <NavButton
                  title='Menu'
                  customFunc={() => setActiveMenu(!activeMenu)}
                  color='white'
                  icon={activeMenu ? <MdOutlineCancel /> : <AiOutlineMenu />}
                />
              </div>

              <Tooltip content='Profile' position='BottomCenter'>
                <div
                  className='flex items-right gap-2 cursor-pointer p-1 hover:bg-opacity-80 rounded-lg'
                  onClick={() => handleClick('userProfile')}
                >
                  {user && (
                    <>
                      <img
                        className='rounded-full h-8 w-8'
                        src={user.image_url ? user.image_url : avatar}
                        alt='user-profile'
                      />
                      <p className='text-white'>
                        <span className='text-14'>Привет, </span>
                        <span className='font-bold ml-1 text-14'>
                          {user.first_name}
                        </span>
                      </p>
                    </>
                  )}
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      {/* Rest of the component remains the same */}
      {/* Secondary Navbar */}
      <div className='bg-white shadow-md'>
        <div className='mx-auto px-4'>
          <div className='flex gap-4 py-2 overflow-x-auto whitespace-nowrap no-scrollbar'>
            {currentLinks
              .find(section => section.title === selectedSection)
              ?.links.map((link) => (
                <NavLink
                  to={`/${link.url}/`}
                  key={link.name}
                  className={({ isActive }) =>
                    `px-4 py-2 rounded-lg text-sm ${isLinkActive(isActive, link.url)
                      ? 'bg-gray-100 text-blue-600 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'
                    }`
                  }
                  end
                >
                  {link.name}
                </NavLink>
              ))}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {activeMenu && (
        <div className='md:hidden bg-white border-t max-h-[calc(100vh-120px)] overflow-y-auto no-scrollbar'>
          {currentLinks.map((item) => (
            <div key={item.title} className='px-4 py-2'>
              <button
                className={`flex items-center gap-2 w-full p-2 rounded
                  ${selectedSection === item.title
                    ? 'bg-opacity-80'
                    : 'text-gray-600 hover:bg-gray-100'
                  }`}
                style={{
                  backgroundColor: selectedSection === item.title ? currentColor : 'transparent',
                  color: selectedSection === item.title ? 'white' : 'inherit'
                }}
                onClick={() => setSelectedSection(item.title)}
              >
                <NavIcon
                  iconId={`icon-${item.url?.toLowerCase()}`}
                  className={selectedSection === item.title ? 'text-white' : 'text-white'}
                />
                {item.title}
              </button>
              {selectedSection === item.title && (
                <div className='ml-8 mt-2 transition-all duration-300'>
                  {item.links.map((link) => (
                    <NavLink
                      to={`/${link.url}/`}
                      key={link.name}
                      onClick={() => setActiveMenu(false)}
                      className={({ isActive }) =>
                        `block px-4 py-2 rounded-lg text-sm ${isLinkActive(isActive, link.url)
                          ? 'bg-gray-100 text-blue-600 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                        }`
                      }
                      end
                    >
                      {link.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Popups */}
      {navbarState.cart && <Cart />}
      {navbarState.chat && <Chat />}
      {navbarState.notification && <Notification />}
      {navbarState.userProfile && <UserProfile />}
    </div>
  );
};

export default Navbar;